// Pagination : gère aria-current="page"
document.addEventListener('click', (e) => {
    const pg = e.target.closest('[data-pagination]');
    const btn = e.target.closest('.page, .page-nav');
    if (!pg || !btn) return;

    const pages = [...pg.querySelectorAll('.page')];
    let idx = pages.findIndex(p => p.getAttribute('aria-current') === 'page');
    if (idx < 0) idx = 0;

    if (btn.hasAttribute('data-prev')) {
        idx = Math.max(0, idx - 1);
    } else if (btn.hasAttribute('data-next')) {
        idx = Math.min(pages.length - 1, idx + 1);
    } else if (btn.classList.contains('page')) {
        idx = pages.indexOf(btn);
    }

    pages.forEach((p, i) => {
        if (i === idx) p.setAttribute('aria-current', 'page');
        else p.removeAttribute('aria-current');
    });
});
